export const TIME_ZONE_ES = [
  {
    name: "(GMT-11:00) Hora de Niue",
    timezone: "Pacific/Niue",
  },
  {
    name: "(GMT-11:00) Hora estándar de Samoa",
    timezone: "Pacific/Pago_Pago",
  },
  {
    name: "(GMT-10:00) Hora de Tahití",
    timezone: "Pacific/Tahiti",
  },
  {
    name: "(GMT-10:00) Hora estándar de Hawái-Aleutianas",
    timezone: "Pacific/Honolulu",
  },
  {
    name: "(GMT-10:00) Hora estándar de las Islas Cook",
    timezone: "Pacific/Rarotonga",
  },
  {
    name: "(GMT-09:30) Hora de Marquesas",
    timezone: "Pacific/Marquesas",
  },
  {
    name: "(GMT-09:00) Hora de Gambier",
    timezone: "Pacific/Gambier",
  },
  {
    name: "(GMT-09:00) Hora de Hawái-Aleutianas (Adak)",
    timezone: "America/Adak",
  },
  {
    name: "(GMT-08:00) Hora de Alaska - Anchorage",
    timezone: "America/Anchorage",
  },
  {
    name: "(GMT-08:00) Hora de Alaska - Juneau",
    timezone: "America/Juneau",
  },
  {
    name: "(GMT-08:00) Hora de Alaska - Metlakatla",
    timezone: "America/Metlakatla",
  },
  {
    name: "(GMT-08:00) Hora de Alaska - Nome",
    timezone: "America/Nome",
  },
  {
    name: "(GMT-08:00) Hora de Alaska - Sitka",
    timezone: "America/Sitka",
  },
  {
    name: "(GMT-08:00) Hora de Alaska - Yakutat",
    timezone: "America/Yakutat",
  },
  {
    name: "(GMT-08:00) Hora de Pitcairn",
    timezone: "Pacific/Pitcairn",
  },
  {
    name: "(GMT-07:00) Hora del Pacífico - Los Ángeles",
    timezone: "America/Los_Angeles",
  },
  {
    name: "(GMT-07:00) Hora del Pacífico - Tijuana",
    timezone: "America/Tijuana",
  },
  {
    name: "(GMT-07:00) Hora del Pacífico - Vancouver",
    timezone: "America/Vancouver",
  },
  {
    name: "(GMT-07:00) Hora estándar de las Montañas Rocosas - Creston",
    timezone: "America/Creston",
  },
  {
    name: "(GMT-07:00) Hora estándar de las Montañas Rocosas - Dawson",
    timezone: "America/Dawson",
  },
  {
    name: "(GMT-07:00) Hora estándar de las Montañas Rocosas - Dawson Creek",
    timezone: "America/Dawson_Creek",
  },
  {
    name: "(GMT-07:00) Hora estándar de las Montañas Rocosas - Fort Nelson",
    timezone: "America/Fort_Nelson",
  },
  {
    name: "(GMT-07:00) Hora estándar de las Montañas Rocosas - Phoenix",
    timezone: "America/Phoenix",
  },
  {
    name: "(GMT-07:00) Hora estándar de las Montañas Rocosas - Whitehorse",
    timezone: "America/Whitehorse",
  },
  {
    name: "(GMT-07:00) Hora estándar del Pacífico de México",
    timezone: "America/Hermosillo",
  },
  {
    name: "(GMT-06:00) Hora de Galápagos",
    timezone: "Pacific/Galapagos",
  },
  {
    name: "(GMT-06:00) Hora de las Montañas Rocosas - Boise",
    timezone: "America/Boise",
  },
  {
    name: "(GMT-06:00) Hora de las Montañas Rocosas - Cambridge Bay",
    timezone: "America/Cambridge_Bay",
  },
  {
    name: "(GMT-06:00) Hora de las Montañas Rocosas - Denver",
    timezone: "America/Denver",
  },
  {
    name: "(GMT-06:00) Hora de las Montañas Rocosas - Edmonton",
    timezone: "America/Edmonton",
  },
  {
    name: "(GMT-06:00) Hora de las Montañas Rocosas - Inuvik",
    timezone: "America/Inuvik",
  },
  {
    name: "(GMT-06:00) Hora de las Montañas Rocosas - Ojinaga",
    timezone: "America/Ojinaga",
  },
  {
    name: "(GMT-06:00) Hora de las Montañas Rocosas - Yellowknife",
    timezone: "America/Yellowknife",
  },
  {
    name: "(GMT-06:00) Hora del Pacífico de México - Chihuahua",
    timezone: "America/Chihuahua",
  },
  {
    name: "(GMT-06:00) Hora del Pacífico de México - Mazatlán",
    timezone: "America/Mazatlan",
  },
  {
    name: "(GMT-06:00) Hora estándar central - Belice",
    timezone: "America/Belize",
  },
  {
    name: "(GMT-06:00) Hora estándar central - Costa Rica",
    timezone: "America/Costa_Rica",
  },
  {
    name: "(GMT-06:00) Hora estándar central - El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    name: "(GMT-06:00) Hora estándar central - Guatemala",
    timezone: "America/Guatemala",
  },
  {
    name: "(GMT-06:00) Hora estándar central - Managua",
    timezone: "America/Managua",
  },
  {
    name: "(GMT-06:00) Hora estándar central - Regina",
    timezone: "America/Regina",
  },
  {
    name: "(GMT-06:00) Hora estándar central - Swift Current",
    timezone: "America/Swift_Current",
  },
  {
    name: "(GMT-06:00) Hora estándar central - Tegucigalpa",
    timezone: "America/Tegucigalpa",
  },
  {
    name: "(GMT-05:00) Hora central - Bahía de Banderas",
    timezone: "America/Bahia_Banderas",
  },
  {
    name: "(GMT-05:00) Hora central - Beulah, Dakota del Norte",
    timezone: "America/North_Dakota/Beulah",
  },
  {
    name: "(GMT-05:00) Hora central - Center, Dakota del Norte",
    timezone: "America/North_Dakota/Center",
  },
  {
    name: "(GMT-05:00) Hora central - Chicago",
    timezone: "America/Chicago",
  },
  {
    name: "(GMT-05:00) Hora central - Ciudad de México",
    timezone: "America/Mexico_City",
  },
  {
    name: "(GMT-05:00) Hora central - Knox, Indiana",
    timezone: "America/Indiana/Knox",
  },
  {
    name: "(GMT-05:00) Hora central - Matamoros",
    timezone: "America/Matamoros",
  },
  {
    name: "(GMT-05:00) Hora central - Menominee",
    timezone: "America/Menominee",
  },
  {
    name: "(GMT-05:00) Hora central - Mérida",
    timezone: "America/Merida",
  },
  {
    name: "(GMT-05:00) Hora central - Monterrey",
    timezone: "America/Monterrey",
  },
  {
    name: "(GMT-05:00) Hora central - New Salem, Dakota del Norte",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    name: "(GMT-05:00) Hora central - Rainy River",
    timezone: "America/Rainy_River",
  },
  {
    name: "(GMT-05:00) Hora central - Rankin Inlet",
    timezone: "America/Rankin_Inlet",
  },
  {
    name: "(GMT-05:00) Hora central - Resolute",
    timezone: "America/Resolute",
  },
  {
    name: "(GMT-05:00) Hora central - Tell City, Indiana",
    timezone: "America/Indiana/Tell_City",
  },
  {
    name: "(GMT-05:00) Hora central - Winnipeg",
    timezone: "America/Winnipeg",
  },
  {
    name: "(GMT-05:00) Hora de Ecuador",
    timezone: "America/Guayaquil",
  },
  {
    name: "(GMT-05:00) Hora de la isla de Pascua",
    timezone: "Pacific/Easter",
  },
  {
    name: "(GMT-05:00) Hora estándar de Acre - Eirunepé",
    timezone: "America/Eirunepe",
  },
  {
    name: "(GMT-05:00) Hora estándar de Acre - Río Branco",
    timezone: "America/Rio_Branco",
  },
  {
    name: "(GMT-05:00) Hora estándar de Colombia",
    timezone: "America/Bogota",
  },
  {
    name: "(GMT-05:00) Hora estándar de Perú",
    timezone: "America/Lima",
  },
  {
    name: "(GMT-05:00) Hora estándar oriental - Atikokan",
    timezone: "America/Atikokan",
  },
  {
    name: "(GMT-05:00) Hora estándar oriental - Cancún",
    timezone: "America/Cancun",
  },
  {
    name: "(GMT-05:00) Hora estándar oriental - Jamaica",
    timezone: "America/Jamaica",
  },
  {
    name: "(GMT-05:00) Hora estándar oriental - Panamá",
    timezone: "America/Panama",
  },
  {
    name: "(GMT-04:00) Hora de Bolivia",
    timezone: "America/La_Paz",
  },
  {
    name: "(GMT-04:00) Hora de Cuba",
    timezone: "America/Havana",
  },
  {
    name: "(GMT-04:00) Hora de Guyana",
    timezone: "America/Guyana",
  },
  {
    name: "(GMT-04:00) Hora de Paraguay",
    timezone: "America/Asuncion",
  },
  {
    name: "(GMT-04:00) Hora de Venezuela",
    timezone: "America/Caracas",
  },
  {
    name: "(GMT-04:00) Hora estándar del Amazonas - Boa Vista",
    timezone: "America/Boa_Vista",
  },
  {
    name: "(GMT-04:00) Hora estándar del Amazonas - Campo Grande",
    timezone: "America/Campo_Grande",
  },
  {
    name: "(GMT-04:00) Hora estándar del Amazonas - Cuiabá",
    timezone: "America/Cuiaba",
  },
  {
    name: "(GMT-04:00) Hora estándar del Amazonas - Manaos",
    timezone: "America/Manaus",
  },
  {
    name: "(GMT-04:00) Hora estándar del Amazonas - Porto Velho",
    timezone: "America/Porto_Velho",
  },
  {
    name: "(GMT-04:00) Hora estándar del Atlántico - Barbados",
    timezone: "America/Barbados",
  },
  {
    name: "(GMT-04:00) Hora estándar del Atlántico - Blanc-Sablon",
    timezone: "America/Blanc-Sablon",
  },
  {
    name: "(GMT-04:00) Hora estándar del Atlántico - Curazao",
    timezone: "America/Curacao",
  },
  {
    name: "(GMT-04:00) Hora estándar del Atlántico - Martinica",
    timezone: "America/Martinique",
  },
  {
    name: "(GMT-04:00) Hora estándar del Atlántico - Puerto España",
    timezone: "America/Port_of_Spain",
  },
  {
    name: "(GMT-04:00) Hora estándar del Atlántico - Puerto Rico",
    timezone: "America/Puerto_Rico",
  },
  {
    name: "(GMT-04:00) Hora estándar del Atlántico - Santo Domingo",
    timezone: "America/Santo_Domingo",
  },
  {
    name: "(GMT-04:00) Hora oriental - Detroit",
    timezone: "America/Detroit",
  },
  {
    name: "(GMT-04:00) Hora oriental - Gran Turca",
    timezone: "America/Grand_Turk",
  },
  {
    name: "(GMT-04:00) Hora oriental - Indianápolis",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    name: "(GMT-04:00) Hora oriental - Iqaluit",
    timezone: "America/Iqaluit",
  },
  {
    name: "(GMT-04:00) Hora oriental - Louisville",
    timezone: "America/Kentucky/Louisville",
  },
  {
    name: "(GMT-04:00) Hora oriental - Marengo, Indiana",
    timezone: "America/Indiana/Marengo",
  },
  {
    name: "(GMT-04:00) Hora oriental - Monticello, Kentucky",
    timezone: "America/Kentucky/Monticello",
  },
  {
    name: "(GMT-04:00) Hora oriental - Nassau",
    timezone: "America/Nassau",
  },
  {
    name: "(GMT-04:00) Hora oriental - Nipigon",
    timezone: "America/Nipigon",
  },
  {
    name: "(GMT-04:00) Hora oriental - Nueva York",
    timezone: "America/New_York",
  },
  {
    name: "(GMT-04:00) Hora oriental - Pangnirtung",
    timezone: "America/Pangnirtung",
  },
  {
    name: "(GMT-04:00) Hora oriental - Petersburg, Indiana",
    timezone: "America/Indiana/Petersburg",
  },
  {
    name: "(GMT-04:00) Hora oriental - Puerto Príncipe",
    timezone: "America/Port-au-Prince",
  },
  {
    name: "(GMT-04:00) Hora oriental - Thunder Bay",
    timezone: "America/Thunder_Bay",
  },
  {
    name: "(GMT-04:00) Hora oriental - Toronto",
    timezone: "America/Toronto",
  },
  {
    name: "(GMT-04:00) Hora oriental - Vevay, Indiana",
    timezone: "America/Indiana/Vevay",
  },
  {
    name: "(GMT-04:00) Hora oriental - Vincennes, Indiana",
    timezone: "America/Indiana/Vincennes",
  },
  {
    name: "(GMT-04:00) Hora oriental - Winamac, Indiana",
    timezone: "America/Indiana/Winamac",
  },
  {
    name: "(GMT-03:00) Hora de Chile",
    timezone: "America/Santiago",
  },
  {
    name: "(GMT-03:00) Hora de la Guayana Francesa",
    timezone: "America/Cayenne",
  },
  {
    name: "(GMT-03:00) Hora de Palmer",
    timezone: "Antarctica/Palmer",
  },
  {
    name: "(GMT-03:00) Hora de Punta Arenas",
    timezone: "America/Punta_Arenas",
  },
  {
    name: "(GMT-03:00) Hora de Rothera",
    timezone: "Antarctica/Rothera",
  },
  {
    name: "(GMT-03:00) Hora de Surinam",
    timezone: "America/Paramaribo",
  },
  {
    name: "(GMT-03:00) Hora del Atlántico - Bermudas",
    timezone: "Atlantic/Bermuda",
  },
  {
    name: "(GMT-03:00) Hora del Atlántico - Glace Bay",
    timezone: "America/Glace_Bay",
  },
  {
    name: "(GMT-03:00) Hora del Atlántico - Goose Bay",
    timezone: "America/Goose_Bay",
  },
  {
    name: "(GMT-03:00) Hora del Atlántico - Halifax",
    timezone: "America/Halifax",
  },
  {
    name: "(GMT-03:00) Hora del Atlántico - Moncton",
    timezone: "America/Moncton",
  },
  {
    name: "(GMT-03:00) Hora del Atlántico - Thule",
    timezone: "America/Thule",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Buenos Aires",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Catamarca",
    timezone: "America/Argentina/Catamarca",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Córdoba",
    timezone: "America/Argentina/Cordoba",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Jujuy",
    timezone: "America/Argentina/Jujuy",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - La Rioja",
    timezone: "America/Argentina/La_Rioja",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Mendoza",
    timezone: "America/Argentina/Mendoza",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Río Gallegos",
    timezone: "America/Argentina/Rio_Gallegos",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Salta",
    timezone: "America/Argentina/Salta",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - San Juan",
    timezone: "America/Argentina/San_Juan",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - San Luis",
    timezone: "America/Argentina/San_Luis",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Tucumán",
    timezone: "America/Argentina/Tucuman",
  },
  {
    name: "(GMT-03:00) Hora estándar de Argentina - Ushuaia",
    timezone: "America/Argentina/Ushuaia",
  },
  {
    name: "(GMT-03:00) Hora estándar de Brasilia - Araguaína",
    timezone: "America/Araguaina",
  },
  {
    name: "(GMT-03:00) Hora estándar de Brasilia - Bahía",
    timezone: "America/Bahia",
  },
  {
    name: "(GMT-03:00) Hora estándar de Brasilia - Belén",
    timezone: "America/Belem",
  },
  {
    name: "(GMT-03:00) Hora estándar de Brasilia - Fortaleza",
    timezone: "America/Fortaleza",
  },
  {
    name: "(GMT-03:00) Hora estándar de Brasilia - Maceió",
    timezone: "America/Maceio",
  },
  {
    name: "(GMT-03:00) Hora estándar de Brasilia - Recife",
    timezone: "America/Recife",
  },
  {
    name: "(GMT-03:00) Hora estándar de Brasilia - Santarém",
    timezone: "America/Santarem",
  },
  {
    name: "(GMT-03:00) Hora estándar de Brasilia - São Paulo",
    timezone: "America/Sao_Paulo",
  },
  {
    name: "(GMT-03:00) Hora estándar de las islas Malvinas",
    timezone: "Atlantic/Stanley",
  },
  {
    name: "(GMT-03:00) Hora estándar de Uruguay",
    timezone: "America/Montevideo",
  },
  {
    name: "(GMT-02:30) Hora de Terranova",
    timezone: "America/St_Johns",
  },
  {
    name: "(GMT-02:00) Hora de Georgia del Sur",
    timezone: "Atlantic/South_Georgia",
  },
  {
    name: "(GMT-02:00) Hora de Groenlandia occidental",
    timezone: "America/Nuuk",
  },
  {
    name: "(GMT-02:00) Hora de San Pedro y Miquelón",
    timezone: "America/Miquelon",
  },
  {
    name: "(GMT-02:00) Hora estándar de Fernando de Noronha",
    timezone: "America/Noronha",
  },
  {
    name: "(GMT-01:00) Hora estándar de Cabo Verde",
    timezone: "Atlantic/Cape_Verde",
  },
  {
    name: "(GMT+00:00) Hora de Groenlandia oriental",
    timezone: "America/Scoresbysund",
  },
  {
    name: "(GMT+00:00) Hora de las Azores",
    timezone: "Atlantic/Azores",
  },
  {
    name: "(GMT+00:00) Hora del meridiano de Greenwich",
    timezone: "Etc/GMT",
  },
  {
    name: "(GMT+00:00) Hora del meridiano de Greenwich - Abiyán",
    timezone: "Africa/Abidjan",
  },
  {
    name: "(GMT+00:00) Hora del meridiano de Greenwich - Acra",
    timezone: "Africa/Accra",
  },
  {
    name: "(GMT+00:00) Hora del meridiano de Greenwich - Bisáu",
    timezone: "Africa/Bissau",
  },
  {
    name: "(GMT+00:00) Hora del meridiano de Greenwich - Danmarkshavn",
    timezone: "America/Danmarkshavn",
  },
  {
    name: "(GMT+00:00) Hora del meridiano de Greenwich - Monrovia",
    timezone: "Africa/Monrovia",
  },
  {
    name: "(GMT+00:00) Hora del meridiano de Greenwich - Reikiavik",
    timezone: "Atlantic/Reykjavik",
  },
  {
    name: "(GMT+00:00) Hora del meridiano de Greenwich - Santo Tomé",
    timezone: "Africa/Sao_Tome",
  },
  {
    name: "(GMT+00:00) Tiempo universal coordinado",
    timezone: "UTC",
  },
  {
    name: "(GMT+01:00) Hora de Europa occidental - Canarias",
    timezone: "Atlantic/Canary",
  },
  {
    name: "(GMT+01:00) Hora de Europa occidental - Islas Feroe",
    timezone: "Atlantic/Faroe",
  },
  {
    name: "(GMT+01:00) Hora de Europa occidental - Lisboa",
    timezone: "Europe/Lisbon",
  },
  {
    name: "(GMT+01:00) Hora de Europa occidental - Madeira",
    timezone: "Atlantic/Madeira",
  },
  {
    name: "(GMT+01:00) Hora de Irlanda",
    timezone: "Europe/Dublin",
  },
  {
    name: "(GMT+01:00) Hora de Marruecos",
    timezone: "Africa/Casablanca",
  },
  {
    name: "(GMT+01:00) Hora de Reino Unido",
    timezone: "Europe/London",
  },
  {
    name: "(GMT+01:00) Hora de Sáhara Occidental",
    timezone: "Africa/El_Aaiun",
  },
  {
    name: "(GMT+01:00) Hora estándar de África occidental - Lagos",
    timezone: "Africa/Lagos",
  },
  {
    name: "(GMT+01:00) Hora estándar de África occidental - Yamena",
    timezone: "Africa/Ndjamena",
  },
  {
    name: "(GMT+01:00) Hora estándar de Europa central - Argel",
    timezone: "Africa/Algiers",
  },
  {
    name: "(GMT+01:00) Hora estándar de Europa central - Túnez",
    timezone: "Africa/Tunis",
  },
  {
    name: "(GMT+02:00) Hora de África central - Jartún",
    timezone: "Africa/Khartoum",
  },
  {
    name: "(GMT+02:00) Hora de África central - Maputo",
    timezone: "Africa/Maputo",
  },
  {
    name: "(GMT+02:00) Hora de África central - Windhoek",
    timezone: "Africa/Windhoek",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Ámsterdam",
    timezone: "Europe/Amsterdam",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Andorra",
    timezone: "Europe/Andorra",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Belgrado",
    timezone: "Europe/Belgrade",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Berlín",
    timezone: "Europe/Berlin",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Bruselas",
    timezone: "Europe/Brussels",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Budapest",
    timezone: "Europe/Budapest",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Ceuta",
    timezone: "Africa/Ceuta",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Copenhague",
    timezone: "Europe/Copenhagen",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Estocolmo",
    timezone: "Europe/Stockholm",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Gibraltar",
    timezone: "Europe/Gibraltar",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Luxemburgo",
    timezone: "Europe/Luxembourg",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Madrid",
    timezone: "Europe/Madrid",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Malta",
    timezone: "Europe/Malta",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Mónaco",
    timezone: "Europe/Monaco",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Oslo",
    timezone: "Europe/Oslo",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - París",
    timezone: "Europe/Paris",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Praga",
    timezone: "Europe/Prague",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Roma",
    timezone: "Europe/Rome",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Tirana",
    timezone: "Europe/Tirane",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Varsovia",
    timezone: "Europe/Warsaw",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Viena",
    timezone: "Europe/Vienna",
  },
  {
    name: "(GMT+02:00) Hora de Europa central - Zúrich",
    timezone: "Europe/Zurich",
  },
  {
    name: "(GMT+02:00) Hora de Sudáfrica",
    timezone: "Africa/Johannesburg",
  },
  {
    name: "(GMT+02:00) Hora de Troll",
    timezone: "Antarctica/Troll",
  },
  {
    name: "(GMT+02:00) Hora estándar de Europa oriental - El Cairo",
    timezone: "Africa/Cairo",
  },
  {
    name: "(GMT+02:00) Hora estándar de Europa oriental - Kaliningrado",
    timezone: "Europe/Kaliningrad",
  },
  {
    name: "(GMT+02:00) Hora estándar de Europa oriental - Trípoli",
    timezone: "Africa/Tripoli",
  },
  {
    name: "(GMT+03:00) Hora de África oriental - Juba",
    timezone: "Africa/Juba",
  },
  {
    name: "(GMT+03:00) Hora de África oriental - Nairobi",
    timezone: "Africa/Nairobi",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Ammán",
    timezone: "Asia/Amman",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Atenas",
    timezone: "Europe/Athens",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Beirut",
    timezone: "Asia/Beirut",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Bucarest",
    timezone: "Europe/Bucharest",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Chisináu",
    timezone: "Europe/Chisinau",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Damasco",
    timezone: "Asia/Damascus",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Gaza",
    timezone: "Asia/Gaza",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Hebrón",
    timezone: "Asia/Hebron",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Helsinki",
    timezone: "Europe/Helsinki",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Kiev",
    timezone: "Europe/Kiev",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Nicosia",
    timezone: "Asia/Nicosia",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Riga",
    timezone: "Europe/Riga",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Sofía",
    timezone: "Europe/Sofia",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Tallin",
    timezone: "Europe/Tallinn",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Úzhgorod",
    timezone: "Europe/Uzhgorod",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Vilna",
    timezone: "Europe/Vilnius",
  },
  {
    name: "(GMT+03:00) Hora de Europa oriental - Zaporiyia",
    timezone: "Europe/Zaporozhye",
  },
  {
    name: "(GMT+03:00) Hora de Famagusta",
    timezone: "Asia/Famagusta",
  },
  {
    name: "(GMT+03:00) Hora de Israel",
    timezone: "Asia/Jerusalem",
  },
  {
    name: "(GMT+03:00) Hora de Kírov",
    timezone: "Europe/Kirov",
  },
  {
    name: "(GMT+03:00) Hora de Syowa",
    timezone: "Antarctica/Syowa",
  },
  {
    name: "(GMT+03:00) Hora de Turquía",
    timezone: "Europe/Istanbul",
  },
  {
    name: "(GMT+03:00) Hora estándar de Arabia - Bagdad",
    timezone: "Asia/Baghdad",
  },
  {
    name: "(GMT+03:00) Hora estándar de Arabia - Catar",
    timezone: "Asia/Qatar",
  },
  {
    name: "(GMT+03:00) Hora estándar de Arabia - Riad",
    timezone: "Asia/Riyadh",
  },
  {
    name: "(GMT+03:00) Hora estándar de Moscú - Minsk",
    timezone: "Europe/Minsk",
  },
  {
    name: "(GMT+03:00) Hora estándar de Moscú - Moscú",
    timezone: "Europe/Moscow",
  },
  {
    name: "(GMT+03:00) Hora estándar de Moscú - Simferópol",
    timezone: "Europe/Simferopol",
  },
  {
    name: "(GMT+03:30) Hora de Irán",
    timezone: "Asia/Tehran",
  },
  {
    name: "(GMT+04:00) Hora de Astracán",
    timezone: "Europe/Astrakhan",
  },
  {
    name: "(GMT+04:00) Hora de Reunión",
    timezone: "Indian/Reunion",
  },
  {
    name: "(GMT+04:00) Hora de Sarátov",
    timezone: "Europe/Saratov",
  },
  {
    name: "(GMT+04:00) Hora de Seychelles",
    timezone: "Indian/Mahe",
  },
  {
    name: "(GMT+04:00) Hora de Uliánovsk",
    timezone: "Europe/Ulyanovsk",
  },
  {
    name: "(GMT+04:00) Hora estándar de Armenia",
    timezone: "Asia/Yerevan",
  },
  {
    name: "(GMT+04:00) Hora estándar de Azerbaiyán",
    timezone: "Asia/Baku",
  },
  {
    name: "(GMT+04:00) Hora estándar de Georgia",
    timezone: "Asia/Tbilisi",
  },
  {
    name: "(GMT+04:00) Hora estándar de Mauricio",
    timezone: "Indian/Mauritius",
  },
  {
    name: "(GMT+04:00) Hora estándar de Samara",
    timezone: "Europe/Samara",
  },
  {
    name: "(GMT+04:00) Hora estándar de Volgogrado",
    timezone: "Europe/Volgograd",
  },
  {
    name: "(GMT+04:00) Hora estándar del Golfo",
    timezone: "Asia/Dubai",
  },
  {
    name: "(GMT+04:30) Hora de Afganistán",
    timezone: "Asia/Kabul",
  },
  {
    name: "(GMT+05:00) Hora de Antártida y Territorios Australes Franceses",
    timezone: "Indian/Kerguelen",
  },
  {
    name: "(GMT+05:00) Hora de Kazajistán occidental - Aktau",
    timezone: "Asia/Aqtau",
  },
  {
    name: "(GMT+05:00) Hora de Kazajistán occidental - Aktobe",
    timezone: "Asia/Aqtobe",
  },
  {
    name: "(GMT+05:00) Hora de Kazajistán occidental - Atyrau",
    timezone: "Asia/Atyrau",
  },
  {
    name: "(GMT+05:00) Hora de Kazajistán occidental - Kyzylorda",
    timezone: "Asia/Qyzylorda",
  },
  {
    name: "(GMT+05:00) Hora de Kazajistán occidental - Oral",
    timezone: "Asia/Oral",
  },
  {
    name: "(GMT+05:00) Hora de Maldivas",
    timezone: "Indian/Maldives",
  },
  {
    name: "(GMT+05:00) Hora de Mawson",
    timezone: "Antarctica/Mawson",
  },
  {
    name: "(GMT+05:00) Hora de Tayikistán",
    timezone: "Asia/Dushanbe",
  },
  {
    name: "(GMT+05:00) Hora estándar de Ekaterimburgo",
    timezone: "Asia/Yekaterinburg",
  },
  {
    name: "(GMT+05:00) Hora estándar de Pakistán",
    timezone: "Asia/Karachi",
  },
  {
    name: "(GMT+05:00) Hora estándar de Turkmenistán",
    timezone: "Asia/Ashgabat",
  },
  {
    name: "(GMT+05:00) Hora estándar de Uzbekistán - Samarcanda",
    timezone: "Asia/Samarkand",
  },
  {
    name: "(GMT+05:00) Hora estándar de Uzbekistán - Taskent",
    timezone: "Asia/Tashkent",
  },
  {
    name: "(GMT+05:30) Hora estándar de la India - Calcuta",
    timezone: "Asia/Kolkata",
  },
  {
    name: "(GMT+05:30) Hora estándar de la India - Colombo",
    timezone: "Asia/Colombo",
  },
  {
    name: "(GMT+05:45) Hora de Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    name: "(GMT+06:00) Hora de Bután",
    timezone: "Asia/Thimphu",
  },
  {
    name: "(GMT+06:00) Hora de Kazajistán oriental - Almaty",
    timezone: "Asia/Almaty",
  },
  {
    name: "(GMT+06:00) Hora de Kazajistán oriental - Kostanái",
    timezone: "Asia/Qostanay",
  },
  {
    name: "(GMT+06:00) Hora de Kirguistán",
    timezone: "Asia/Bishkek",
  },
  {
    name: "(GMT+06:00) Hora de Ürümqi",
    timezone: "Asia/Urumqi",
  },
  {
    name: "(GMT+06:00) Hora de Vostok",
    timezone: "Antarctica/Vostok",
  },
  {
    name: "(GMT+06:00) Hora del océano Índico",
    timezone: "Indian/Chagos",
  },
  {
    name: "(GMT+06:00) Hora estándar de Bangladés",
    timezone: "Asia/Dhaka",
  },
  {
    name: "(GMT+06:00) Hora estándar de Omsk",
    timezone: "Asia/Omsk",
  },
  {
    name: "(GMT+06:30) Hora de las Islas Cocos",
    timezone: "Indian/Cocos",
  },
  {
    name: "(GMT+06:30) Hora de Myanmar",
    timezone: "Asia/Yangon",
  },
  {
    name: "(GMT+07:00) Hora de Barnaúl",
    timezone: "Asia/Barnaul",
  },
  {
    name: "(GMT+07:00) Hora de Davis",
    timezone: "Antarctica/Davis",
  },
  {
    name: "(GMT+07:00) Hora de Indochina - Bangkok",
    timezone: "Asia/Bangkok",
  },
  {
    name: "(GMT+07:00) Hora de Indochina - Ciudad Ho Chi Minh",
    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    name: "(GMT+07:00) Hora de Indonesia occidental - Pontianak",
    timezone: "Asia/Pontianak",
  },
  {
    name: "(GMT+07:00) Hora de Indonesia occidental - Yakarta",
    timezone: "Asia/Jakarta",
  },
  {
    name: "(GMT+07:00) Hora de la Isla de Navidad",
    timezone: "Indian/Christmas",
  },
  {
    name: "(GMT+07:00) Hora de Tomsk",
    timezone: "Asia/Tomsk",
  },
  {
    name: "(GMT+07:00) Hora estándar de Hovd",
    timezone: "Asia/Hovd",
  },
  {
    name: "(GMT+07:00) Hora estándar de Krasnoyarsk - Krasnoyarsk",
    timezone: "Asia/Krasnoyarsk",
  },
  {
    name: "(GMT+07:00) Hora estándar de Krasnoyarsk - Novokuznetsk",
    timezone: "Asia/Novokuznetsk",
  },
  {
    name: "(GMT+07:00) Hora estándar de Novosibirsk",
    timezone: "Asia/Novosibirsk",
  },
  {
    name: "(GMT+08:00) Hora de Brunéi",
    timezone: "Asia/Brunei",
  },
  {
    name: "(GMT+08:00) Hora de Indonesia central",
    timezone: "Asia/Makassar",
  },
  {
    name: "(GMT+08:00) Hora de Malasia - Kuala Lumpur",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    name: "(GMT+08:00) Hora de Malasia - Kuching",
    timezone: "Asia/Kuching",
  },
  {
    name: "(GMT+08:00) Hora de Singapur",
    timezone: "Asia/Singapore",
  },
  {
    name: "(GMT+08:00) Hora estándar de Australia occidental - Casey",
    timezone: "Antarctica/Casey",
  },
  {
    name: "(GMT+08:00) Hora estándar de Australia occidental - Perth",
    timezone: "Australia/Perth",
  },
  {
    name: "(GMT+08:00) Hora estándar de China - Macao",
    timezone: "Asia/Macau",
  },
  {
    name: "(GMT+08:00) Hora estándar de China - Shanghái",
    timezone: "Asia/Shanghai",
  },
  {
    name: "(GMT+08:00) Hora estándar de Filipinas",
    timezone: "Asia/Manila",
  },
  {
    name: "(GMT+08:00) Hora estándar de Hong Kong",
    timezone: "Asia/Hong_Kong",
  },
  {
    name: "(GMT+08:00) Hora estándar de Irkutsk",
    timezone: "Asia/Irkutsk",
  },
  {
    name: "(GMT+08:00) Hora estándar de Taipéi",
    timezone: "Asia/Taipei",
  },
  {
    name: "(GMT+08:00) Hora estándar de Ulán Bator - Choibalsan",
    timezone: "Asia/Choibalsan",
  },
  {
    name: "(GMT+08:00) Hora estándar de Ulán Bator - Ulán Bator",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    name: "(GMT+08:45) Hora estándar de Australia centroccidental",
    timezone: "Australia/Eucla",
  },
  {
    name: "(GMT+09:00) Hora de Indonesia oriental",
    timezone: "Asia/Jayapura",
  },
  {
    name: "(GMT+09:00) Hora de Palaos",
    timezone: "Pacific/Palau",
  },
  {
    name: "(GMT+09:00) Hora de Timor Oriental",
    timezone: "Asia/Dili",
  },
  {
    name: "(GMT+09:00) Hora estándar de Corea - Pyongyang",
    timezone: "Asia/Pyongyang",
  },
  {
    name: "(GMT+09:00) Hora estándar de Corea - Seúl",
    timezone: "Asia/Seoul",
  },
  {
    name: "(GMT+09:00) Hora estándar de Japón",
    timezone: "Asia/Tokyo",
  },
  {
    name: "(GMT+09:00) Hora estándar de Yakutsk - Chitá",
    timezone: "Asia/Chita",
  },
  {
    name: "(GMT+09:00) Hora estándar de Yakutsk - Khandyga",
    timezone: "Asia/Khandyga",
  },
  {
    name: "(GMT+09:00) Hora estándar de Yakutsk - Yakutsk",
    timezone: "Asia/Yakutsk",
  },
  {
    name: "(GMT+09:30) Hora de Australia central - Adelaida",
    timezone: "Australia/Adelaide",
  },
  {
    name: "(GMT+09:30) Hora de Australia central - Broken Hill",
    timezone: "Australia/Broken_Hill",
  },
  {
    name: "(GMT+09:30) Hora estándar de Australia central",
    timezone: "Australia/Darwin",
  },
  {
    name: "(GMT+10:00) Hora de Australia oriental - Currie",
    timezone: "Australia/Currie",
  },
  {
    name: "(GMT+10:00) Hora de Australia oriental - Hobart",
    timezone: "Australia/Hobart",
  },
  {
    name: "(GMT+10:00) Hora de Australia oriental - Melbourne",
    timezone: "Australia/Melbourne",
  },
  {
    name: "(GMT+10:00) Hora de Australia oriental - Sídney",
    timezone: "Australia/Sydney",
  },
  {
    name: "(GMT+10:00) Hora de Chuuk",
    timezone: "Pacific/Chuuk",
  },
  {
    name: "(GMT+10:00) Hora de Dumont-d’Urville",
    timezone: "Antarctica/DumontDUrville",
  },
  {
    name: "(GMT+10:00) Hora de Papúa Nueva Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    name: "(GMT+10:00) Hora estándar de Australia oriental - Brisbane",
    timezone: "Australia/Brisbane",
  },
  {
    name: "(GMT+10:00) Hora estándar de Australia oriental - Lindeman",
    timezone: "Australia/Lindeman",
  },
  {
    name: "(GMT+10:00) Hora estándar de Chamorro",
    timezone: "Pacific/Guam",
  },
  {
    name: "(GMT+10:00) Hora estándar de Vladivostok - Ust-Nera",
    timezone: "Asia/Ust-Nera",
  },
  {
    name: "(GMT+10:00) Hora estándar de Vladivostok - Vladivostok",
    timezone: "Asia/Vladivostok",
  },
  {
    name: "(GMT+10:30) Hora de Lord Howe",
    timezone: "Australia/Lord_Howe",
  },
  {
    name: "(GMT+11:00) Hora de Bougainville",
    timezone: "Pacific/Bougainville",
  },
  {
    name: "(GMT+11:00) Hora de Kosrae",
    timezone: "Pacific/Kosrae",
  },
  {
    name: "(GMT+11:00) Hora de la isla Macquarie",
    timezone: "Antarctica/Macquarie",
  },
  {
    name: "(GMT+11:00) Hora de la isla Norfolk",
    timezone: "Pacific/Norfolk",
  },
  {
    name: "(GMT+11:00) Hora de las Islas Salomón",
    timezone: "Pacific/Guadalcanal",
  },
  {
    name: "(GMT+11:00) Hora de Pohnpei",
    timezone: "Pacific/Pohnpei",
  },
  {
    name: "(GMT+11:00) Hora de Srednekolimsk",
    timezone: "Asia/Srednekolymsk",
  },
  {
    name: "(GMT+11:00) Hora estándar de Magadán",
    timezone: "Asia/Magadan",
  },
  {
    name: "(GMT+11:00) Hora estándar de Nueva Caledonia",
    timezone: "Pacific/Noumea",
  },
  {
    name: "(GMT+11:00) Hora estándar de Sajalín",
    timezone: "Asia/Sakhalin",
  },
  {
    name: "(GMT+11:00) Hora estándar de Vanuatu",
    timezone: "Pacific/Efate",
  },
  {
    name: "(GMT+12:00) Hora de Fiyi",
    timezone: "Pacific/Fiji",
  },
  {
    name: "(GMT+12:00) Hora de la isla Wake",
    timezone: "Pacific/Wake",
  },
  {
    name: "(GMT+12:00) Hora de las islas Gilbert",
    timezone: "Pacific/Tarawa",
  },
  {
    name: "(GMT+12:00) Hora de las Islas Marshall - Kwajalein",
    timezone: "Pacific/Kwajalein",
  },
  {
    name: "(GMT+12:00) Hora de las Islas Marshall - Majuro",
    timezone: "Pacific/Majuro",
  },
  {
    name: "(GMT+12:00) Hora de Nauru",
    timezone: "Pacific/Nauru",
  },
  {
    name: "(GMT+12:00) Hora de Nueva Zelanda",
    timezone: "Pacific/Auckland",
  },
  {
    name: "(GMT+12:00) Hora de Tuvalu",
    timezone: "Pacific/Funafuti",
  },
  {
    name: "(GMT+12:00) Hora de Wallis y Futuna",
    timezone: "Pacific/Wallis",
  },
  {
    name: "(GMT+12:00) Hora estándar de Anadyr",
    timezone: "Asia/Anadyr",
  },
  {
    name: "(GMT+12:00) Hora estándar de Kamchatka",
    timezone: "Asia/Kamchatka",
  },
  {
    name: "(GMT+12:45) Hora de Chatham",
    timezone: "Pacific/Chatham",
  },
  {
    name: "(GMT+13:00) Hora de Apia",
    timezone: "Pacific/Apia",
  },
  {
    name: "(GMT+13:00) Hora de las Islas Fénix",
    timezone: "Pacific/Enderbury",
  },
  {
    name: "(GMT+13:00) Hora de Tokelau",
    timezone: "Pacific/Fakaofo",
  },
  {
    name: "(GMT+13:00) Hora estándar de Tonga",
    timezone: "Pacific/Tongatapu",
  },
  {
    name: "(GMT+14:00) Hora de las Espóradas Ecuatoriales",
    timezone: "Pacific/Kiritimati",
  },
];
